!(function() {
    const searchBox = document.querySelector('.header__search-box')

    // Nosto replaces the result button asynchronously.  The old code started a
    // new 50ms interval on every click and attached another handler on every
    // tick, with no exit path while the query was empty.  Observe only the
    // search box for replacement nodes and use one delegated click handler.
    if (searchBox) {
        const revealViewAllButton = () => {
            searchBox.querySelectorAll('button.ns-ac-footer-viewresults').forEach((button) => {
                button.style.opacity = '1'
            })
        }

        revealViewAllButton()
        if (typeof MutationObserver !== 'undefined') {
            const observer = new MutationObserver(revealViewAllButton)
            observer.observe(searchBox, { childList: true, subtree: true })
        }
    }

    // Nosto can portal its result footer outside the header search container.
    // One document-level delegate handles both DOM placements without polling
    // or per-render listeners.
    document.addEventListener('click', (event) => {
        const submitButton = event.target.closest && event.target.closest('button.ns-ac-footer-viewresults')
        if (!submitButton) return

        const searchInput = document.querySelector('[data-header-search-input]')
        const query = searchInput && searchInput.value.trim()
        if (!query) return

        event.preventDefault()
        window.location.href = `/search?q=${encodeURIComponent(query)}`
    })
})()
